<template>
  <div id="liveReplay">
    <div class="container">
      <video
        class="video"
        :src="media_url"
        ref="myVideo"
        autoplay="true"
        controls="controls"
        @click="changePlay"
      >
        <source :src="media_url" type="video/mp4" />
        您的浏览器不支持Video标签。
      </video>
    </div>
  </div>
</template>
<script>
export default {
  name: "liveReplay",
  data() {
    return {
      media_url: "",
    };
  },
  created(){
    this.getWindowsURL();
  },
  mounted(){
    this.canPlay();
  },
  methods: {
    /**
     * 获取小程序传参
     */
    getWindowsURL() {
      let url = decodeURIComponent(window.location.href);
      let params = url.split("?")[1];
      this.media_url = params.split("=")[1] + '?vframe/jpg/offset/1';
    },
    /**
     * 是否可以播放
     */
    canPlay(){
      if (this.$refs.myVideo.canplay()) {
        this.$refs.myVideo.play();
      }
    },
    /**
     * 视频的播放和暂停
     */
    changePlay() {
      if (this.$refs.myVideo.paused) {
        this.$refs.myVideo.play();
      } else {
        this.$refs.myVideo.pause();
      }
    },
  },
};
</script>
<style scoped>
.container {
  position: relative;
  display: flex;
  align-items: center;
  width: 7.5rem;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.video {
  width: 7.5rem;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/qcwy/liveReplay.vue